import React, { useEffect, useState } from "react";

export default function InvestorNavbar() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <div
      style={{
        width: "100%",
        background: "#1e293b",
        color: "#fff",
        padding: isMobile ? "12px 14px" : "14px 20px",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        gap: isMobile ? "10px" : "0px",
        boxSizing: "border-box",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: isMobile ? "18px" : "20px",
          lineHeight: "1.3",
          wordBreak: "break-word",
        }}
      >
        Magnira Univese LLP
      </h3>

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
          gap: "10px",
          width: isMobile ? "100%" : "auto",
        }}
      >
        <span
          style={{
            fontSize: isMobile ? "14px" : "15px",
            fontWeight: "500",
            wordBreak: "break-word",
          }}
        >
          👤 {user?.name || "Investor"}
        </span>

        <button
          onClick={handleLogout}
          style={{
            padding: "10px 14px",
            background: "red",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            width: isMobile ? "100%" : "auto",
            fontSize: "14px",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
